import React from "react";
import { RefreshCw } from "lucide-react";

type Props = {
  className?: string;
  size?: number;
};

export default function IconRefreshCw({ className, size = 16 }: Props) {
  return <RefreshCw className={className} width={size} height={size} />;
}
